import request from "@/utils/request";
import { cleanObjectFromUndefined } from "@/utils/utils";

const customSortingKeys = [];

export async function getAllAddresses({
  page = 1,
  pageSize = 10,

  dealerId,
  isPublic,
  filter = "",
  cities,
  stateIds,

  city,
  stateId,

  securePassAutoSendType,
  securePassMissingContact,

  sorting,
}) {
  const currentPage = page - 1;

  const SkipCount = currentPage * pageSize;
  let Sorting;
  let CustomSorting;

  if (typeof sorting === "string" && sorting.indexOf(":") !== -1) {
    const [sortBy, sortOrder] = sorting.split(":");

    if (customSortingKeys.indexOf(sortBy) !== -1) {
      CustomSorting = `${sortBy.slice(0, 1).toUpperCase() + sortBy.slice(1, sortBy.length)} ${sortOrder}`;
    } else {
      Sorting = `${sortBy} ${sortOrder}`;
    }
  }

  if (typeof city === "string") {
    if (!Array.isArray(cities)) {
      cities = [city];
    } else {
      cities = [...cities, city];
    }
  }

  if (typeof stateId === "string") {
    if (!Array.isArray(stateIds)) {
      stateIds = [stateId];
    } else {
      stateIds = [...stateIds, stateId];
    }
  }

  const params = cleanObjectFromUndefined({
    SkipCount,
    MaxResultCount: pageSize,

    DealerId: dealerId,
    IsPublic: isPublic,
    FilterText: filter || undefined,
    Cities: cities,
    StateIds: stateIds,
    AutosendType: securePassAutoSendType,
    MissingPickupContact: securePassMissingContact,

    Sorting,
    CustomSorting,
  });

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/addresses`, {
    method: "GET",
    params,
  });

  return result?.data;
}

export async function getSingleShipmentAddress(addressId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/addresses/${addressId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function getSingleAddress(addressId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/addresses/${addressId}`, {});

  return result?.data;
}

export async function updateAddress(addressId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/addresses/${addressId}`, {
    method: "PUT",
    data,
  });

  if (result?.response?.status === 200 && result?.data) {
    return result.data;
  }

  return { error: true };
}

export async function getAddressByEntity(entityId, searchText) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/addresses`, {
    params: {
      DealerId: entityId,
      MaxResultCount: 100,
      FilterText: searchText,
    },
  });

  return result?.data;
}

export async function createNewAddress(payload) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/addresses`, {
    method: "POST",
    data: payload,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function createPublicAddress(payload) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/addresses/public`, {
    method: "POST",
    data: payload,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function deleteAddress(addressId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/addresses/${addressId}`, {
    method: "DELETE",
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return { error: false };
}

export async function importPublicAddresses(fileData) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/addresses/import-public`, {
    method: "POST",
    data: fileData,
  });

  return result || { error: true };
}

export async function importAddresses(fileData, dealerId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/addresses/import?DealerId=${dealerId}`, {
    method: "POST",
    data: fileData,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function getAllStates() {
  const params = {
    SkipCount: 0,
    MaxResultCount: 100,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/states`, {
    method: "GET",
    params,
  });

  return result.data;
}

export async function getStateById(stateId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/states/${stateId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function getAllCities({ stateId = undefined, page = 0, pageSize = 1000, filterText = undefined }) {
  const SkipCount = page * pageSize;

  const params = cleanObjectFromUndefined({
    StateId: stateId,
    SkipCount,
    MaxResultCount: pageSize,
    FilterText: filterText,
  });

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/cities`, {
    params,
  });

  return result?.data;
}

export async function getCityById(cityId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/cities/${cityId}`, {
    method: "GET",
  });

  return result?.data;
}
